<template>
    <div>
        <hgroup class="d-block d-md-none">
            <h3>{{ profile.name }}</h3>
            <h4>Your specific choices below</h4>
        </hgroup>
        <h3 class="d-none d-md-block">{{ profile.name }} -- Your specific choices below</h3>
        <hr class="my-4" />

        <ui-nav class="content-nav flex-nowrap overflow-auto text-nowrap">
            <ui-nav-item v-for="(label, key) in groups" :key="`profile-${profile.id}-choices-nav-${key}`" :active="currentGroup == key" @click="currentGroup = key" class="pt-3 pt-lg-0">
                {{ label }}
            </ui-nav-item>
        </ui-nav>

        <media-row v-if="gallery" :media="gallery" class="mt-4" size="lg" @click="(index) => openGallery(index)" />
        <p v-else>Could not find any image selected under this group.</p>

        <gallery-modal v-if="showGallery" :media="gallery" :active="showGalleryIndex" @close="closeGallery"/>

        <divider />

        <top-slide :image="footerImage" :thin="true" :centerContent="true" class="rounded overflow-hidden">
            <div class="text-center">
                <h3>Diverse Tastes?</h3>
                <ui-button to="/aesthetic-profile" color="secondary">
                    Create Another Aesthetic Profile
                </ui-button>
            </div>
        </top-slide>
    </div>
</template>
<script type="text/javascript">
    import TopSlide from '@/components/Content/TopSlide.vue';
    import CommonComponents from '@/components/Common.vue';

    import Media from '@/classes/Media.js';
    import UI from '@/classes/UI.js';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            TopSlide,
            ...CommonComponents,
        },

        data() {
            return {

                showGallery: false,
                showGalleryIndex: 0,

                groups: {
                    kitchen: 'Kitchen',
                    interior: 'Living Room',
                    bedroom: 'Bedrooms',
                    bathroom: 'Bathrooms',
                    exterior: 'Exterior',
                },

                currentGroup: 'kitchen',

                footerImage: UI.randomExteriorImages(1),

            };
        },

        props: {
            profile: {
                type: ApiObject,
                required: true,
            }
        },

        computed: {

            gallery() {
                let re = [];
                if (
                    (this.profile) &&
                    (this.profile.images) &&
                    (this.profile.images.length)
                ) {
                    for (let i=0; i<this.profile.images.length; i++) {
                        if (this.profile.images[i].group == this.currentGroup) {
                            re.push(new Media(this.profile.images[i].src, this.profile.images[i].src, null, 'image'));
                        }
                    }
                }

                if (re.length) {
                    return re;
                }
                return null;
            },
        },

        methods: {

            openGallery(index) {
                this.showGalleryIndex = index;
                this.showGallery = true;
            },

            closeGallery() {
                this.showGallery = false;
                this.showGalleryIndex = 0;
            },
        }
    }
</script>